import React, { FunctionComponent, useEffect, useState } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  MenuItem,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";

import BolgeKoduAPI from "../../../apis/OB/Get/BolgeKoduAPI";
import MahalleListeAPI from "../../../apis/OB/Get/MahalleListeAPI";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import SuIcKapiListeApi from "../../../apis/OB/Get/SuIcKapiListeApi";
import SuDisKapiListeAPI from "../../../apis/OB/Get/SuDisKapiListeAPI";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import  SessionStorageService  from "../../../services/StorageService";
import KacakSuIhbarAPI from "../../../apis/OB/SaveApi/KacakSuIhbarAPI";
import TcTelefonSmsControlPopup from "../../../components/OB/popups/tc-telefon-fogrulama-popup";

const KacakSuIhbar: FunctionComponent = () => {
  const [bolgeKoduDatas, setBolgeKoduDatas] = useState<any[]>([]);
  const [mahalleKoduDatas, setMahalleKoduDatas] = useState<any[]>([]);
  const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
  const [disKapiDatas, setDisKapiDatas] = useState<any[]>([]);
  const [icKapiDatas, setIcKapiDatas] = useState<any[]>([]);
  const [popupContent, setPopupContent] = useState<string>("");
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const user=SessionStorageService.getUserInfo()

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupContent("");
  };

  const formik = useFormik({
    initialValues: {
        basvuruTuruId:306,
      bolgeKodu: -1,
      mahalleKodu: -1,
      caddeSokakKodu: -1,
      disKapiNo: "",
      icKapiNo: "",
      aciklama: "",
    },
    validationSchema: Yup.object({
      bolgeKodu: Yup.number().min(0, "Bolge Kodu boş bırakılamaz").required("Bolge Kodu boş bırakılamaz"),
      mahalleKodu: Yup.number().min(0, "Mahalle Kodu boş bırakılamaz").required("Mahalle Kodu boş bırakılamaz"),
      caddeSokakKodu: Yup.number().min(0, "Cadde Sokak Kodu boş bırakılamaz").required("Cadde Sokak Kodu boş bırakılamaz"),
      disKapiNo: Yup.string().required("Dış Kapı No boş bırakılamaz"),
      aciklama: Yup.string().required("Açıklama boş bırakılamaz"),
    }),
    onSubmit: (values,{resetForm}) => {
      // Form submission logic
      KacakSuIhbarAPI.saveKacakBasvuruBasvuruSave(values)
          .then((res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;
              setPopupContent(
                "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
                basvuruNo
              );
              resetForm();
              setKayitBasarili(true);
            } else {
                setPopupContent(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupContent(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
          });
    },
  });

  useEffect(() => {
    BolgeKoduAPI.getBolgeKoduiste(undefined)
      .then((res) => {
        setBolgeKoduDatas(res.data);
      })
      .catch((err) => {
        console.error("Bolge Kodu API hatası:", err);
      });
  }, []);

  useEffect(() => {
    if (formik.values.bolgeKodu !== -1) {
      MahalleListeAPI.getMahalleListe(formik.values.bolgeKodu, undefined)
        .then((res) => {
          setMahalleKoduDatas(res.data);
        })
        .catch((err) => {
          console.error("Mahalle Liste API hatası:", err);
        });
    } else {
      setMahalleKoduDatas([]);
      formik.setFieldValue("mahalleKodu", -1);
    }
  }, [formik.values.bolgeKodu]);

  useEffect(() => {
    if (formik.values.mahalleKodu !== -1) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, formik.values.mahalleKodu)
        .then((res) => {
          setCaddeSokakDatas(res.data);
        })
        .catch((err) => {
          console.error("Cadde Sokak Liste API hatası:", err);
        });
    } else {
      setCaddeSokakDatas([]);
      formik.setFieldValue("caddeSokakKodu", -1);
    }
  }, [formik.values.mahalleKodu]);

  useEffect(() => {
    if (
      formik.values.mahalleKodu !== -1 &&
      formik.values.bolgeKodu !== -1 &&
      formik.values.caddeSokakKodu !== -1
    ) {
      SuDisKapiListeAPI.getSuDisKapiListe(
        formik.values.bolgeKodu,
        formik.values.mahalleKodu,
        formik.values.caddeSokakKodu
      )
        .then((res) => {
          setDisKapiDatas(res.data);
        })
        .catch((err) => {
          console.error("Su Dis Kapi Liste API hatası:", err);
        });
    }
  }, [formik.values.caddeSokakKodu, formik.values.mahalleKodu, formik.values.bolgeKodu]);

  useEffect(() => {
    if (
      formik.values.mahalleKodu !== -1 &&
      formik.values.disKapiNo !== "" &&
      formik.values.caddeSokakKodu !== -1
    ) {
      SuIcKapiListeApi.getSuIcKapiListe(
        formik.values.disKapiNo,
        formik.values.mahalleKodu,
        formik.values.caddeSokakKodu
      )
        .then((res) => {
          setIcKapiDatas(res.data);
        })
        .catch((err) => {
          console.error("Su Ic Kapi Liste API hatası:", err);
        });
    }
  }, [formik.values.caddeSokakKodu, formik.values.mahalleKodu, formik.values.disKapiNo]);

  const requiredInputControl = () => {
    const errors: string[] = [];
    if (formik.values.bolgeKodu === -1) {
      errors.push("Bolge Kodu boş bırakılamaz");
    }
    if (formik.values.mahalleKodu === -1) {
      errors.push("Mahalle Kodu boş bırakılamaz");
    }
    if (formik.values.caddeSokakKodu === -1) {
      errors.push("Cadde Sokak Kodu boş bırakılamaz");
    }
    if (formik.values.disKapiNo === "") {
      errors.push("Dış Kapı No boş bırakılamaz");
    }
    if (formik.values.aciklama === "") {
      errors.push("Açıklama boş bırakılamaz");
    }
    return errors;
  };

  const clearAllInputs = () => {
    formik.resetForm();
    setMahalleKoduDatas([]);
    setCaddeSokakDatas([]);
    setDisKapiDatas([]);
    setIcKapiDatas([]);
  };
  const [smsControlled, setSmsControlled] = useState(user != null);
  const [tcKimlikNo, setTcKimlikNo] = useState(user ? user.tcKimlikNo : "");
  const [cepTelefonu, setCepTelefonu] = useState("");
  const closePopup = () => {
    setIsPopupVisible(false);
  };

  return !smsControlled ?  <TcTelefonSmsControlPopup
  smsControlledSet={setSmsControlled}
  cepTelefonuSet={setCepTelefonu}
  tcKimlikNoSet={setTcKimlikNo}
/>
:(
   
      <><Card>
      <CardContent>
      <Container >
        <FormikProvider value={formik}>
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Bolge Kodu"
                  value={formik.values.bolgeKodu}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="bolgeKodu"
                  error={formik.touched.bolgeKodu && Boolean(formik.errors.bolgeKodu)}
                  helperText={formik.touched.bolgeKodu && formik.errors.bolgeKodu}
                >
                  <MenuItem value={-1}>Lütfen Seçiniz...</MenuItem>
                  {bolgeKoduDatas.map((item, index) => (
                    <MenuItem key={index} value={item.bolgeKodu}>
                      {item.bolgeAdi}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Mahalle"
                  value={formik.values.mahalleKodu}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="mahalleKodu"
                  error={formik.touched.mahalleKodu && Boolean(formik.errors.mahalleKodu)}
                  helperText={formik.touched.mahalleKodu && formik.errors.mahalleKodu}
                >
                  <MenuItem value={-1}>Lütfen Seçiniz...</MenuItem>
                  {mahalleKoduDatas.map((item, index) => (
                    <MenuItem key={index} value={item.mahalleKodu}>
                      {item.mahalleAdi}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Cadde/Sokak"
                  value={formik.values.caddeSokakKodu}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="caddeSokakKodu"
                  error={formik.touched.caddeSokakKodu && Boolean(formik.errors.caddeSokakKodu)}
                  helperText={formik.touched.caddeSokakKodu && formik.errors.caddeSokakKodu}
                >
                  <MenuItem value={-1}>Lütfen Seçiniz...</MenuItem>
                  {caddeSokakDatas.map((item, index) => (
                    <MenuItem key={index} value={item.caddeSokakKodu}>
                      {item.caddeSokakAdi}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Dış Kapı No"
                  value={formik.values.disKapiNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="disKapiNo"
                  error={formik.touched.disKapiNo && Boolean(formik.errors.disKapiNo)}
                  helperText={formik.touched.disKapiNo && formik.errors.disKapiNo}
                >
                  <MenuItem value="">Lütfen Seçiniz...</MenuItem>
                  {disKapiDatas.map((item, index) => (
                    <MenuItem key={index} value={item.disKapiNo}>
                      {item.disKapiNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="İç Kapı No"
                  value={formik.values.icKapiNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="icKapiNo"
                  error={formik.touched.icKapiNo && Boolean(formik.errors.icKapiNo)}
                  helperText={formik.touched.icKapiNo && formik.errors.icKapiNo}
                >
                  <MenuItem value="">Lütfen Seçiniz...</MenuItem>
                  {icKapiDatas.map((item, index) => (
                    <MenuItem key={index} value={item.icKapiNo}>
                      {item.icKapiNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Açıklama"
                  value={formik.values.aciklama}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="aciklama"
                  error={formik.touched.aciklama && Boolean(formik.errors.aciklama)}
                  helperText={formik.touched.aciklama && formik.errors.aciklama}
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid className="d-flex justify-content-between" item xs={12} >
               
                <Button variant="contained" color="secondary" onClick={clearAllInputs}>
                  Temizle
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Gönder
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
        </Container>
      </CardContent>
    </Card>
    {isPopupVisible && (
      <BilgilendirmePopup
      basvuruTuruId={formik.values.basvuruTuruId}
      isSorunBildirPopup={!kayitBasarili}
      closePopup={closePopupSonuc}
      open={isPopupVisible}
      editDescription={popupContent}
    />
    )}</>
   
  );
};

export default KacakSuIhbar;
